import * as React from 'react';
import { observer, inject } from 'mobx-react';
import { ClientEntryStore } from '../stores/client-entry-store';
import { ClientEntry } from '../components/client/client-entry';
import { UserStore } from '../stores/user-store';
import { ClientDisplay } from '../components/client/client-display';
import { BloodworkEntryStore } from '../stores/bloodwork-entry-store';
import { UserProfileUIStore } from '../stores/user-profile-ui-store';

interface ClientEntryContainerProps {
  userProfileUIStore: UserProfileUIStore;
  clientEntryStore?: ClientEntryStore;
  userStore?: UserStore;
  bloodworkEntryStore: BloodworkEntryStore;
  location?: any;
  history?: any;
}

@inject('userProfileUIStore', 'clientEntryStore', 'userStore', 'bloodworkEntryStore')
@observer
// Copied from ClientEntryContainer due to issues when user is editing a client and
// then clicks on Add Client.  The previous client wasn't being reset.
export class ClientAddContainer extends React.Component<ClientEntryContainerProps, {}> {

  componentDidMount() {
    const { clientEntryStore, userStore } = this.props;
    userStore.loadCurrentUser();
    clientEntryStore.loadCurrentClients();
    clientEntryStore.resetCurrentClient();
    clientEntryStore.setExpandAddClient(true);
  }

  render() {
    const { userProfileUIStore, clientEntryStore, userStore, bloodworkEntryStore } = this.props;
    return (
      <div className="section">
        <ClientEntry
          client={clientEntryStore.currentClient}
          currentUser={userStore.currentUser}
          clientEntryStore={clientEntryStore}
          saveOrUpdate={() => clientEntryStore.saveOrUpdate()}
          expandAddClient={clientEntryStore.expandAddClient}
          defaultUnits={userProfileUIStore.currentUserProfile?.unitSystem}
          history={this.props.history}
        />
        <ClientDisplay
          currentUserProfile={userProfileUIStore.currentUserProfile}
          clients={clientEntryStore.clients}
          clientEntryStore={clientEntryStore}
          bloodworkEntryStore={bloodworkEntryStore}
          history={this.props.history}
        />
      </div>
    );
  }
}